/*
  価格帯の絞り込み（つまみ2つのスライダー ＋ 金額の入力欄）
  snippets/price-range-slider.liquid ／ assets/component-price-slider.css とセット。

  ■ カスタム要素にしている理由
    Dawnは絞り込みを変えるたびにサイドバーのHTMLを差し替える（FacetFiltersForm.renderPage）。
    ふつうのスクリプトで一度だけ配線すると、1回絞り込んだ時点で動かなくなる。
    カスタム要素なら差し替え後の要素にも自動でつながる。

  ■ 送信のタイミング（Dawnの仕組みに合わせている）
    Dawnは絞り込みフォームの **input** を0.5秒デバウンスして送信する（change ではない）。
    ・つまみのドラッグ中 … input を stopPropagation で止める。→ 途中で何度も通信しない
    ・つまみを離したとき … 入力欄に値を入れ、そこから input を1回だけ発火 → 0.5秒後に送信
    ・入力欄に手打ち     … Dawn標準どおり、打ち終わって0.5秒後に送信

  ■ 空のときは name を外す
    値が無い側は name 属性を外す。name が無い input はフォームから送られないので、
    URLに `filter.v.price.gte=` のような空パラメータが残らない。

  ■ ⚠️ Dawn標準の <price-range> は使わない
    あれは空欄を0と解釈し、前回の値が残った min 属性まで押し戻すので、
    「上限を外す」と勝手に前の下限値が入ってしまう（2026-08-24に実測）。値の補正はここで行う。
*/
(function () {
  class PriceRangeSlider extends HTMLElement {
    connectedCallback() {
      this.lo = this.querySelector('.cc-prs__thumb--lo');
      this.hi = this.querySelector('.cc-prs__thumb--hi');
      this.loInput = this.querySelector('[data-price-role="gte"]');
      this.hiInput = this.querySelector('[data-price-role="lte"]');
      if (!this.lo || !this.hi || !this.loInput || !this.hiInput) return;

      this.max = parseInt(this.dataset.max, 10) || 0;

      /* ドラッグ中：表示だけ更新し、フォームには伝えない */
      ['lo', 'hi'].forEach((side) => {
        this[side].addEventListener('input', (event) => {
          event.stopPropagation();
          this.pushApart(side);
          this.paint();
        });
        /* 離したとき：1回だけ送信させる */
        this[side].addEventListener('change', (event) => {
          event.stopPropagation();
          this.paint();
          this.requestSubmit();
        });
      });

      /* 手打ち：打っている間はスライダーだけ追随（送信はDawnに任せる） */
      ['loInput', 'hiInput'].forEach((key) => {
        this[key].addEventListener('input', () => this.syncFromInputs(false));
        this[key].addEventListener('change', () => this.syncFromInputs(true));
      });

      this.paint();
    }

    /* 2つのつまみが追い越さないように押し返す */
    pushApart(moved) {
      const lo = parseInt(this.lo.value, 10);
      const hi = parseInt(this.hi.value, 10);
      if (lo <= hi) return;
      if (moved === 'lo') {
        this.hi.value = lo;
      } else {
        this.lo.value = hi;
      }
    }

    /* スライダーの現在値を、帯の描画と入力欄に反映する */
    paint() {
      const lo = parseInt(this.lo.value, 10);
      const hi = parseInt(this.hi.value, 10);
      this.style.setProperty('--cc-prs-lo', lo);
      this.style.setProperty('--cc-prs-hi', hi);
      this.setField(this.loInput, lo > 0 ? lo : null);
      this.setField(this.hiInput, hi < this.max ? hi : null);
    }

    /* 値があれば name を付け、無ければ空にして name を外す（送信されないようにする） */
    setField(input, value) {
      if (value === null) {
        input.value = '';
        input.removeAttribute('name');
      } else {
        input.value = value;
        input.setAttribute('name', input.dataset.param);
      }
    }

    /* 入力欄からスライダーへ。clamp=true のときは値の補正もする（離れたタイミング） */
    syncFromInputs(clamp) {
      const read = (el, fallback) => {
        const v = parseInt(el.value, 10);
        if (isNaN(v)) return fallback;
        return Math.min(Math.max(v, 0), this.max);
      };
      let lo = read(this.loInput, 0);
      let hi = read(this.hiInput, this.max);
      if (lo > hi) {
        if (clamp) {
          lo = hi;
        } else {
          return;
        }
      }
      this.lo.value = lo;
      this.hi.value = hi;
      this.style.setProperty('--cc-prs-lo', lo);
      this.style.setProperty('--cc-prs-hi', hi);
      if (clamp) this.paint();
    }

    /* Dawnの絞り込みフォームに「変わった」と伝える（0.5秒デバウンスで送信される） */
    requestSubmit() {
      this.hiInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  if (!customElements.get('price-range-slider')) {
    customElements.define('price-range-slider', PriceRangeSlider);
  }
})();
